module.exports = __webpack_public_path__ + "static/img/jwayelani-logo-full.8ace364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/large/jwayelani-logo-full.png
// module id = X7Cb
// module chunks = 1